module.exports = __webpack_public_path__ + "img/glass.58b590dd.svg";